export default __webpack_public_path__ + "static/media/checked.69a508dc.svg";